import React, {useEffect, useState} from "react";
import {Breadcrumb, Card, Col, Row} from "react-bootstrap";
import {isLoggedIn} from "../../common/utils";
import {useParams} from "react-router-dom";
import VenuesService from "../../services/venues.service";
import Container from "react-bootstrap/Container";
import ContactEntity from "../contact/contactEntity.component";

const VenueContact = () => {
    let {venueId} = useParams();
    const [venue, setVenue] = useState()
    let loggedIn = isLoggedIn();

    const fetchVenue = (venueId) => {
        if (venueId !== undefined) {
            VenuesService.getVenueById(venueId).then(
                response => {
                    setVenue(response.data);
                    console.log("venue:" + JSON.stringify(response.data));
                },
                error => {
                    console.log(error);
                });
        }
    }

    // load once on mount to fetch venue
    useEffect(() => {
        fetchVenue(venueId);
    }, [venueId]); // eslint-disable-line react-hooks/exhaustive-deps

    if (venue !== undefined) {
        return (
            <>
                <Container fluid>
                    <Row>
                        <Col>
                            <h3>
                                <Breadcrumb>
                                    <Breadcrumb.Item active>Venues</Breadcrumb.Item>
                                    <Breadcrumb.Item active>{venue.address}</Breadcrumb.Item>
                                </Breadcrumb>
                            </h3>
                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            <Card>
                                <Card.Body>
                                    <h3 className="mb-3">
                                        Contact
                                    </h3>
                                    {loggedIn &&
                                        <div>
                                            <ContactEntity entityId={venue.id} entityType={"venue"} entityName={venue.address}/>
                                        </div>
                                    }
                                    {!loggedIn &&
                                        <div>
                                            You need to be logged in to contact this venue.
                                        </div>
                                    }
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </>
        )
    }
};

export default VenueContact;